<template>
  <div>
    <list-block>
      <div class="action">
        <h3>货主服务设置</h3>
      </div>
      <list-filter
        :form="form"
        @fetchData="fetchData"
        @resetData="resetData"
      />
    </list-block>
    <list-block>
      <el-table
        v-loading="loading.fetchData"
        :data="tableData"
        border
      >
        <el-table-column
          v-for="item in TABLECOLUMN"
          :key="item.props"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
          :min-width="item.minWidth"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'action'">
              <el-button
                type="text"
                @click="toSetting(scope.row)"
              >
                服务设置
              </el-button>
            </div>
            <div v-else-if="item.prop === 'setting'">
              <div>
                <!-- <span v-if="scope.row.isPlatform">
                  {{ (scope.row.ext && AUTOACCEPTTYPE[scope.row.ext.autoAcceptOrder])|| '手动接单' }}
                </span>
                <span v-else>
                  {{ (scope.row.ext && AUTOACCEPTTYPE[scope.row.ext.transferAcceptOrder])|| '手动接单' }}
                </span> -->
                <span>
                  {{ AUTOACCEPTTYPE[scope.row.isDeal] || '手动接单' }}
                </span>
                <span :class="{notSpecified: !scope.row.isTransfer, specified: true}">{{ scope.row.isTransfer ? '已指定' : '未指定' }}</span>承运商
              </div>
            </div>
            <span
              v-else
              v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
            />
          </template>
        </el-table-column>
      </el-table>
      <pagination
        ref="settingPagination"
        :total="total"
        :page-size="size"
        :current-page="page"
        @search="fetchData"
      />
    </list-block>
  </div>
</template>

<script>
import loadingMixin from '@thales/loading';
import ListBlock from '@/components/ListBlock/index.vue';
import pagination from '@/components/Pagination/index.vue';
import { filterNullParams } from '@/utils/type';
import ListFilter from './components/ListFilter.vue';
import { TABLECOLUMN, CUSTOMERTYPE, AUTOACCEPTTYPE } from './const';
import { getByCorp } from '../api';

export default {
  components: {
    ListFilter,
    ListBlock,
    pagination,
  },
  mixins: [loadingMixin],
  data() {
    return {
      form: {},
      total: 0,
      page: 1,
      size: 10,
      CUSTOMERTYPE,
      AUTOACCEPTTYPE,
      tableData: [],
      TABLECOLUMN,
      loading: {
        fetchData: false,
      },
    };
  },
  async created() {
    this.fetchData();
  },
  methods: {
    toSetting(row) {
      const query = {
        id: row.id,
        active: 1,
        from: 'list',
        code: row.customerCode,
      };
      if (!row.isPlatform) {
        query.notPlatform = true;
      }
      this.$router.push({
        path: 'settingEdit',
        query,
      });
    },
    async fetchData(page, size) {
      this.page = page || this.page;
      this.size = size || this.size;
      const query = {
        page: this.page,
        size: this.size,
        sort: 'create_time__DESC',
      };
      const params = filterNullParams({
        ...this.form,
        ownerTenantId: this.form.ownerTenantId || null,
      });
      const res = await getByCorp(params, query);
      this.total = res.total;
      this.tableData = res.records;
    },
    resetData() {
      this.form = {};
      this.fetchData(1);
    },
  },
};
</script>

<style scoped>
.action {
  text-align: right;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between
}
.notSpecified {
  color: red;
}
</style>
